import type { FC } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Lightbox } from "components/Lightbox";

import IconEnvelopeGreen from "images/icons/envelope-green.svg";
import IconEnvelopeOrange from "images/icons/envelope-orange.svg";
import IconEnvelopeRed from "images/icons/envelope-red.svg";

import { useAppSelector } from "store/hooks";
import { getGrade } from "store/slices/user";

interface Props {
  isShown: boolean;
  onHide: () => void;
}

const EnvelopeExplanation: FC<Props> = ({ isShown, onHide }) => {
  const { t } = useTranslation(["common", "assignments"]);
  const grade = useAppSelector(getGrade);
  const isGraduate = grade === "maturant";

  return (
    <Lightbox
      show={isShown}
      onHide={onHide}
      bodyClassName={"pt-0 px-32px"}
      title={t("subjects.howItWorks", { ns: "assignments" })}
    >
      <p>{t("info.dashboardEnvelope.paragraph1", { ns: "exercise", context: isGraduate ? "graduate" : undefined })}</p>
      <p>
        <Trans i18nKey="info.dashboardEnvelope.paragraph2">
          Úlohy se ti rovnou rozřadí do obálek, takže hned uvidíš, co ti zatím moc nejde (červená obálka{" "}
          <IconEnvelopeRed />
          ), kde naopak válíš (zelená obálka <IconEnvelopeGreen />) a co umíš tak napůl (oranžová obálka{" "}
          <IconEnvelopeOrange />
          ).
        </Trans>
      </p>
      {/* AIDEV-NOTE: Graduates don't buy extra tests like entrance-exam pupils do, so the
          whole purchase paragraph disappears for them. [TD-430] */}
      {!isGraduate && (
        <p className={"mb-20px"}>
          <Trans i18nKey="info.dashboardEnvelope.paragraph3">
            Pokud ti nevyhovuje žádný z vypsaných termínů přijímaček nanečisto, nebo chceš potrénovat ještě víc, můžeš
            si dokoupit{" "}
            <Link to={"https://zona.to-das.cz/_u_a_dashboard.php"} target={"_blank"}>
              samostatné testy s rozborem
            </Link>
            .
          </Trans>
        </p>
      )}
    </Lightbox>
  );
};

export default EnvelopeExplanation;
